<template>
  <v-layout v-if="show" justify-center>
    <v-flex shrink>
      <v-pagination v-model="productsPage" :length="productsPagesLength" total-visible="10" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("ner", [
      "classification",
      "products",
      "productsPagesLength",
      "searchInput"
    ]),
    productsPage: {
      get() {
        return this.$store.state.ner.productsPage;
      },
      set(value) {
        this.setProductsPage(value);
      }
    },
    /* Show this component only if there are products and there is no search performed */
    show() {
      return this.products.length && !this.searchInput;
    }
  },
  methods: {
    ...mapActions("ner", ["getProducts"]),
    ...mapMutations("ner", ["setProductsPage"])
  },
  watch: {
    /* Watch the page and get the products of the page only if there is an active classification */
    productsPage() {
      if (this.classification) {
        return this.getProducts();
      }
    }
  }
};
</script>